import { StaggeredPackageBuilderModel } from './staggered-package-builder.model';
import { Product } from './product.model';


export class KitPackage {
  public package: StaggeredPackageBuilderModel;
  public kitID: string;
  public kit: Product;

  public customerId: string;

  constructor() {
    this.package = new StaggeredPackageBuilderModel();

    this.customerId = sessionStorage.getItem("customerID");
  }
}
